import type { Location, NavigateFunction } from "react-router-dom";
import type { AnyAction, Dispatch } from "redux";
import { MODULES } from "../../../configs/modules";
import { READ } from "../../../configs/operations";
import { LoginResponse } from "../../../utils/getLoginResponse";
import Permissions from "../../../utils/permissions";
import { getUserScreenAccess } from "./ducks/actions";

type InitializePostLoginOptions = {
  dispatch: Dispatch<AnyAction>;
  navigate: NavigateFunction;
  location: Location;
};

type LoginLocationState = {
  pathname?: string;
  search?: string;
};

const getPostLoginPath = (pathname?: string, search?: string): string => {
  if (Permissions.isAllowed(MODULES.PROPERTIES, [READ])) {
    if (pathname && search) return pathname + search;
    return "/dashboard";
  }

  if (Permissions.isAllowed(MODULES.CONFIGURATIONS, [READ])) {
    return "/tickets";
  }

  return "/dashboard";
};

export const initializePostLogin = (result: LoginResponse, options: InitializePostLoginOptions) => {
  const { dispatch, navigate, location } = options;
  const { pathname = null, search = null } = (location.state ?? {}) as LoginLocationState;

  localStorage.setItem("login-response", JSON.stringify(result));
  if (result.orgId) localStorage.setItem("orgId", result.orgId);

  const screens = result.accessibleScreens?.length > 0 ? result.accessibleScreens : [];
  dispatch(getUserScreenAccess(screens));

  const path = getPostLoginPath(pathname, search);
  setTimeout(() => navigate(path), 1400);
};
